module.exports = __webpack_public_path__ + "img/1.af470353.png";